function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-160-60a20,20,0,0,0-20,20,20,20,0,0,0,20,20,20,20,0,0,0,20-20A20,20,0,0,0-160-60Zm-15.862,22H-172a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2h-3.862a20.457,20.457,0,0,1,3.238-7.8l2.724,2.724a2,2,0,0,0,2.828,0h0a2,2,0,0,0,0-2.828l-2.726-2.724a20.457,20.457,0,0,1,7.8-3.238V-52a2,2,0,0,0,2,2h0a2,2,0,0,0,2-2v-3.862a20.457,20.457,0,0,1,7.8,3.238L-152.93-49.9a2,2,0,0,0,0,2.828h0a2,2,0,0,0,2.828,0l2.724-2.726a20.457,20.457,0,0,1,3.238,7.8H-148a2,2,0,0,0-2,2h0a2,2,0,0,0,2,2h3.862a20.457,20.457,0,0,1-3.238,7.8l-2.724-2.724a2,2,0,0,0-2.828,0h0a2,2,0,0,0,0,2.828l2.724,2.724a20.457,20.457,0,0,1-7.8,3.238V-28a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v3.862a20.457,20.457,0,0,1-7.8-3.238l2.724-2.724a2,2,0,0,0,0-2.828h0a2,2,0,0,0-2.828,0l-2.724,2.724A20.457,20.457,0,0,1-175.862-38Z",
  transform: "translate(180 60)"
});

var SvgIconProcess = function SvgIconProcess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconProcess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-process.1fb59fab.svg";
export { ForwardRef as ReactComponent };